import{useAuth as o}from"@phx-husky/use-auth";const t=()=>{const t=o();return{forgotPassword:o=>t.forgotPassword(o),forgotPasswordSubmit:o=>t.forgotPasswordSubmit(o),validate:o=>t.validate(o)}};export{t as useForgotPassword};
